import { useLocation } from "react-router-dom";

export const useLastPath = (path?: string) => {
  const location = useLocation();
  const parts = (path ?? location.pathname).split("/");

  let lastPath = parts[Math.max(0, parts.length - 1)];

  if (!lastPath && parts.length >= 2) {
    lastPath = parts[parts.length - 2];
  }

  return lastPath;
};
